<template>
  <b-row>
    <b-col cols="12">
      <b-card no-body class="mb-1">
        <b-card-header>
          <span class="information-header">Information</span>
        </b-card-header>
        <div class="row mt-2 mb-1 px-5">
          <div class="col-12">
            <b-form-checkbox
              v-model="formData.isActive"
              field-value="true"
              class="custom-control-success custom-toggle"
              name="check-button"
              switch
            >
              <span class="switch-icon-left toggle-text">{{ "Active" }}</span>
              <span class="switch-icon-right toggle-text">{{
                "Inactive"
              }}</span>
            </b-form-checkbox>
          </div>
        </div>
        <div class="row mb-2 px-5">
          <!-- left content -->
          <div class="col-lg-6 col-sm-12 col-xs-12">
            <div class="information-wrp-left mt-1 mb-1">
              <div class="row mb-1">
                <div class="col-6">
                  <b-form-group
                    :label="'Reference'"
                    label-for="reference"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="reference"
                      v-model="formData.reference"
                      disabled
                    />
                  </b-form-group>
                </div>
                <div class="col-6">
                  <label class="font-medium-5">Privilege Type</label>
                  <v-select
                    v-model="formData.privilegeType"
                    class="select-format-container font-medium-5 bg-dropdown"
                    :class="[
                      formData.privilegeType ? 'select-format-selected' : null,
                      { bypass: isEdit },
                    ]"
                    :reduce="(option) => option.value"
                    :options="optionData.privilegeType"
                    required
                    :clearable="false"
                    @input="$emit('onSelectPrivilegeType')"
                  />
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-12">
                  <b-form-group
                    :label="'Name (En)'"
                    label-for="nameEn"
                    label-class="font-medium-5 required"
                  >
                    <b-form-input
                      id="nameEn"
                      v-model="formData.nameEn"
                      required
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-12">
                  <b-form-group
                    :label="'Name (Th)'"
                    label-for="nameTh"
                    label-class="font-medium-5 required"
                  >
                    <b-form-input
                      id="nameTh"
                      v-model="formData.nameTh"
                      required
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-12">
                  <b-form-group
                    :label="'Sub Name (En)'"
                    label-for="subNameEn"
                    label-class="font-medium-5"
                  >
                    <b-form-input id="subNameEn" v-model="formData.subNameEn" />
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-12">
                  <b-form-group
                    :label="'Sub Name (Th)'"
                    label-for="subNameTh"
                    label-class="font-medium-5"
                  >
                    <b-form-input id="subNameTh" v-model="formData.subNameTh" />
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-12">
                  <b-form-group
                    :label="'Detail (En)'"
                    label-for="detailEn"
                    label-class="font-medium-5"
                  >
                    <b-form-textarea
                      id="detailEn"
                      v-model="formData.detailEn"
                      no-resize
                      rows="3"
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-12">
                  <b-form-group
                    :label="'Detail (Tn)'"
                    label-for="detailTh"
                    label-class="font-medium-5"
                  >
                    <b-form-textarea
                      id="detailTh"
                      v-model="formData.detailTh"
                      no-resize
                      rows="3"
                    />
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <!-- right content -->
          <div class="col-lg-6 col-sm-12 col-xs-12">
            <div class="information-wrp-right h-100 pt-1 pb-1">
              <div class="row align-self-stretch m-0 w-100">
                <div class="col-6 pr-0 pl-0">
                  <b-form-group
                    :label="'Assign Inventory'"
                    label-for="assignInventory"
                    label-class="font-medium-5"
                  >
                    <b-button
                      id="assignInventory"
                      class="custom-button w-90"
                      @click="$emit('onSelectInventory')"
                    >
                      <span>{{ "Select Inventory" }}</span>
                    </b-button>
                  </b-form-group>
                </div>
                <!-- <div class="col-6 pr-0 pl-0">
                    <b-form-group
                      :label="'Choose Store'"
                      label-for="chooseStore"
                      label-class="font-medium-5"
                    >
                      <b-button
                        id="chooseStore"
                        class="custom-button w-90"
                        @click="onSelectStore"
                      >
                        <span>{{ 'Select Store' }}</span>
                      </b-button>
                    </b-form-group>
                  </div> -->
              </div>
              <div class="row align-self-stretch m-auto h-100 w-100">
                <div class="col-12 pr-0 pl-0">
                  <div class="editor-wrp h-100 pb-1 mt-1">
                    <label class="font-medium-5 custom-tab-label"
                      >Term and Conditions</label
                    >
                    <b-tabs class="custom-tab flex-stretch h-100">
                      <b-tab
                        :title="'Thai'"
                        title-link-class="font-medium-5"
                        lazy
                      >
                        <quill-editor
                          v-model="formData.ruleTh"
                          class="custom-quill-editor flex-stretch h-100"
                        />
                      </b-tab>
                      <b-tab
                        :title="'English'"
                        title-link-class="font-medium-5"
                        lazy
                      >
                        <quill-editor
                          v-model="formData.ruleEn"
                          class="custom-quill-editor flex-stretch h-100"
                        />
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    formData: { type: Object, default: {} },
    isEdit: { type: Boolean, default: false },
    optionData : { type: Object, default: {} },
  },
};
</script>

<style></style>
